









import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Emit, ModelSync, Prop, Watch } from 'vue-property-decorator'
import { EditorUploadFileUseCase } from '@/modules/common/editor/use-cases/editor-upload-file.use-case'
import tinymce, { RawEditorSettings } from 'tinymce'
import EditorStore from '@/modules/common/editor/stores/editor.store'
import { editorContentCss, editorContentStyle } from '@/modules/common/editor/styles'
import 'tinymce/plugins/image'
import 'tinymce/plugins/media'
import 'tinymce/plugins/link'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/searchreplace'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/directionality'
import 'tinymce/plugins/autosave'
import 'tinymce/plugins/help'

const block_formats = 'Paragraph=p;Heading 2=h2;Heading 3=h3;Heading 4=h4;Heading 5=h5;Heading 6=h6;Preformatted=pre'
  .replaceAll('Heading', 'هدینگ')

@Component
export default class TinyMceEditor extends Vue {
  constructor(
    private readonly store: EditorStore,
    private readonly useCase: EditorUploadFileUseCase
  ) {
    super()
  }

  @ModelSync('value', 'input') content: string
  @Prop({ default: () => ({}) }) customConfig: object

  protected readonly id = Math.random().toString().replace('0.', 't')

  protected editorPlugins = [
    'image',
    'media',
    'link',
    'textcolor',
    'searchreplace',
    'wordcount',
    'paste',
    'lists',
    'fullscreen',
    'directionality',
    // 'autosave',
    'help'
  ]

  protected editorToolbar = [
    ['formatselect'],
    ['bold', 'italic', 'underline'],
    ['forecolor', 'backcolor'],
    ['alignleft', 'aligncenter', 'alignright', 'alignjustify'],
    ['insertfile', 'image'],
    ['link', 'unlink'],
    ['bullist', 'numlist', 'blockquote'],
    ['outdent', 'indent'],
    ['ltr', 'rtl'],
    ['searchreplace', 'fullscreen', 'help']
  ]

  protected editorConfig: RawEditorSettings = {
    id: this.id,
    selector: `#${this.id}`,
    menubar: false,
    convert_urls: false,
    valid_elements: 'h1,h2,h3,h4,h5,h5,p,span,img[*],a[!href|*],blockquote,b,u,i,strong,ul,ol[*],li,br[*],table[*],th[*],tr[*],td[*],thead[*],tbody[*]',
    invalid_elements: 'span',
    extended_valid_elements: '',
    valid_styles: {
      '*': 'color background-color border', // Global valid styles
      'td': 'border-top border-bottom border-left border-right border'
    },
    //directionality: 'rtl',
    skin: false,
    language: 'fa',
    content_css: editorContentCss(),
    content_style: editorContentStyle(),
    plugins: this.editorPlugins,
    paste_data_images: true,
    target_list: false,
    relative_urls: false,
    remove_script_host: false,
    rel_list: [
      { title: 'فالو', value: '' },
      { title: 'نو فالو', value: 'nofollow' }
    ],
    link_assume_external_targets: 'http',
    toolbar: this.editorToolbar.map(toolbarSection => toolbarSection.join(' ')).join(' | '),
    block_formats,
    height: '450',
    selection_toolbar: 'bold italic | h2 h3 | blockquote quicklink',
    images_upload_handler: (blobInfo, success, failure) => {
      this.useCase.execute(blobInfo, success, failure)
    },
    setup: editor => {
      editor.on('NodeChange', event => {
        if (event && event.element.nodeName === 'IMG') {
          const targetElement = event.element
          const width = parseInt(targetElement.getAttribute('width'), 10) || 0
          let height = targetElement.getAttribute('height')
          if (width > 750 || width <= 0) {
            height = 'auto'
          }
          tinymce.DOM.setStyles(targetElement, { 'height': height })
        }

        this.emitContent(editor.getContent())
      })

      editor.on('WordCountUpdate', ({ wordCount: { words } }) => {
        this.$emit('words', words)
      })

      editor.on('input', () => {
        this.emitContent(editor.getContent())
      })

      editor.on('init', () => {
        editor.setContent(this.value)
      })

      editor.on('ExecCommand', function(e) {
        if (e.command === 'copy') {
          let range = editor.dom.createRng()
          range.selectNodeContents(editor.getBody())
          editor.selection.setRng(range)
          editor.execCommand('Copy')
          editor.selection.collapse()
        }
      })

      // editor.on('SelectionChange', () => {
      //   if(tinymce.activeEditor.selection.getContent().length > 0){
      //     //console.log(tinymce.activeEditor.selection.getContent())
      //     if(tinymce.activeEditor.selection.getNode().tagName){
      //       console.log(tinymce.activeEditor.selection.getNode().childNodes)
      //       tinymce.activeEditor.selection.getNode().childNodes.forEach(item => {
      //         if (item.nodeName==='A') console.log(item)
      //       })
      //     }
      //   }
      // })
    }
  }

  private isTyping: boolean = false

  private timeout = null

  @Emit('input')
  emitContent(content) {
    this.isTyping = true
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    this.timeout = setTimeout(() => {
      this.isTyping = false
    })
    return content
  }

  @Watch('value')
  onContentChange(newContent) {
    if (!this.isTyping) {
      tinymce.activeEditor.setContent(newContent)
      this.emitContent(newContent)
    }
  }

  mounted() {
    let config = {
      ...this.editorConfig,
      ...this.customConfig
    }
    tinymce.init(config)
  }

  copyContent() {
    tinymce.activeEditor.execCommand('copy')
  }
}
